import HARDCODE from '../../../business-const/HardCode/HardCode'



const formaAbaterLanceList = [
    {
        id: HARDCODE.idFormaAbaterLanceReduzirParcela,
        descricao: 'Reduzir Parcela',
        ordem: 10,
    },
    {
        id: HARDCODE.idFormaAbaterLanceReduzirPrazo,
        descricao: 'Reduzir Prazo',
        ordem: 20,
    },
]

export default formaAbaterLanceList